export const ALL_LOCATIONS_OPTION = { label: 'All locations', value: '' };
export const ALL_DEPARTMENTS_OPTION = { label: 'All departments', value: '' };
